import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import css from './Modal.module.scss';
import classNames from 'classnames';
import IconX from '@images/icons/IconX/IconX';
import ConditionalWrapper from '@components/ConditionalWrapper/ConditionalWrapper';

const Modal = ({
  isOpen,
  contentLabel,
  contentClass,
  panelContainerClass,
  onClose,
  transparent,
  children,
  showCloseButton = true,
  closeButtonClass,
  withTransition = false,
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog aria-label={contentLabel} as="div" className={css.outerWrapper} onClose={onClose}>
        <ConditionalWrapper
          condition={withTransition}
          wrapper={children => (
            <Transition.Child
              as={Fragment}
              enter={classNames(css.overlayTransition, css.enter)}
              enterFrom={classNames(css.overlayTransition, css.enterFrom)}
              enterTo={classNames(css.overlayTransition, css.enterTo)}
              leave={classNames(css.overlayTransition, css.leave)}
              leaveFrom={classNames(css.overlayTransition, css.leaveFrom)}
              leaveTo={classNames(css.overlayTransition, css.leaveTo)}
            >
              {children}
            </Transition.Child>
          )}
        >
          <div className={classNames(css.overlay, { [css.transparent]: transparent })} />
        </ConditionalWrapper>

        <div className={css.modalWrapper}>
          <div className={contentClass || css.content}>
            <ConditionalWrapper
              condition={withTransition}
              wrapper={children => (
                <Transition.Child
                  as={Fragment}
                  enter={classNames(css.modalTransition, css.enter)}
                  enterFrom={classNames(css.modalTransition, css.enterFrom)}
                  enterTo={classNames(css.modalTransition, css.enterTo)}
                  leave={classNames(css.modalTransition, css.leave)}
                  leaveFrom={classNames(css.modalTransition, css.leaveFrom)}
                  leaveTo={classNames(css.modalTransition, css.leaveTo)}
                >
                  {children}
                </Transition.Child>
              )}
            >
              <Dialog.Panel className={panelContainerClass}>
                {children}
                {showCloseButton ? (
                  <button onClick={onClose} className={classNames(closeButtonClass, css.close)}>
                    <IconX />
                  </button>
                ) : null}
              </Dialog.Panel>
            </ConditionalWrapper>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default Modal;
